module.exports = __webpack_public_path__ + "static/img/GNSS01.8d19889d.png";